/* eslint-disable no-console */
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import PropTypes from 'prop-types';
import PaymentCalculatorController from '../../../containers/PaymentCalculatorController';

import './PaymentCalculator.scss';

let isComposer = false;
class PaymentSummary extends React.Component {
	constructor(props) {
		super(props);

		this.state = { isComposer: false };
		this.handleOpen = (name) => {
			this.props.showModal(name, { message: `This is a ${name} modal` });
		};
		this.trackGa = this.trackGa.bind(this);
	}

	componentDidMount() {
		isComposer = window && window.top && window.top.composer;
		// eslint-disable-next-line react/no-did-mount-set-state
		this.setState({ isComposer });
	}

	trackGa(trackingObj) {
		const DDC = window.DDC || {};
		const defaultTrackingObj = {
			event: 'widgetUserEvent',
			widgetName: 'ws-payment-calculator',
			widgetState: '',
			widgetId: this,
			element: '',
			action: 'clicked',
			result: '',
			elementCta: null
		};

		if (DDC.fireTrackingEvent) {
			DDC.fireTrackingEvent({ ...defaultTrackingObj, ...trackingObj });
		}
	}

	render() {
		let rootComponent = null;
		const { apr, downPayment, selectedAprTerm, monthlyPayment } =
			this.props;

		rootComponent = (
			<Common
				render={({ labels, prefs }) => {
					const { calcPaymentText, buttonClasses, superScriptText } = prefs || {};

					const calcText = calcPaymentText || labels.get('CALCULATE_PAYMENT');
					
					const prefsBtnClasses = buttonClasses || 'btn-primary';
					
					const btnClasses = `btn btn-block payment-summary-calculate ${prefsBtnClasses}`;
					return (
						<div className="payment-summary">
							<form>
								<div className="payment-summary-sample clearfix">
									{/* eslint-disable-next-line jsx-a11y/label-has-for */}
									<label
										htmlFor="sample-payment-value"
										className="pull-left"
									>
										{labels.get('SAMPLE_PAYMENT')}
										<sup>2</sup>:
									</label>
									<div
										id="sample-payment-value"
										className="pull-right payment-summary-dollar"
									>
										<strong>{monthlyPayment}</strong>
										<span>/mo</span>
									</div>
								</div>
								<p className="payment-summary-support-text">
									{selectedAprTerm} {labels.get('MONTHS')} @{' '}
									{apr}% {labels.get('APR')} {downPayment}{' '}
									{labels.get('DOWN_PAYMENT')}
								</p>
								<div className="payment-summary-cta">
									<button
										type='button'
										className={btnClasses}
										onClick={() => {
											this.trackGa({
												element:
													'Payment Calculator Button',
												result: 'Opens payment calculator button',
												widgetId: 'paymentCalculator'
											});
											this.handleOpen('dynamic');
										}}
									>
										{calcText}
										<sup>{superScriptText}</sup>
									</button>
								</div>

								{this.state.isComposer && (
									<div className="payment-calculator-composer">
										<PaymentCalculatorController />
									</div>
								)}
							</form>
						</div>
					);
				}}
			/>
		);
		return rootComponent;
	}
}

PaymentSummary.propTypes = {
	showModal: PropTypes.func.isRequired,
	apr: PropTypes.number.isRequired,
	downPayment: PropTypes.string.isRequired,
	selectedAprTerm: PropTypes.number.isRequired,
	monthlyPayment: PropTypes.string.isRequired
};

export default PaymentSummary;
